import { useSelector, useDispatch } from 'react-redux';
import { dateNumberToString } from '../reusables/Date/helpers';
import { Creators as ProgressiveCertificationActions } from '../../domain/useCases/courses/progressiveCertificationEnabled';

const useExternalSettings = () => {
  const dispatch = useDispatch();
  const { data, isLoading: isExternalLoading } = useSelector(
    (state: any) => state.externalSettings
  );
  const { data: dataPeriods } = useSelector((state: any) => state.getPeriods);

  const currentPeriod = dataPeriods?.find((p: any) => !!p.isCurrent);

  const { data: dataProfile } = useSelector((state: any) => state.profile);
  const {
    data: isProgressiveCertification,
    isLoading: isLoadingProgressiveCert
  } = useSelector((state: any) => state.getProgressiveCertificationEnabled);
  const callProgressiveCertification = () =>
    dispatch(
      ProgressiveCertificationActions.getProgressiveCertificationEnabled(
        dataProfile.academic.plan,
        dataProfile.academic.prog,
        dataProfile.academic.career
      )
    );

  if (!data)
    return { callProgressiveCertification: () => {}, isExternalLoading };
  return {
    callProgressiveCertification,
    isLoadingProgressiveCert,
    isExternalLoading,
    isRolExam: data.enable_rol_examenes === 'true', // data?.isRolExam, ahora viene de flash.config
    isEnrollmentTurn: data.enrollment_enabled === 'true', // data?.isEnrollmentTurn, ahora se usa el de flash.config
    isEnrollmentCardEnabled: data.enrollment_card_enabled === 'true', // courses and schedules
    isCourseCatalog: data.enable_catalogo_cursos === 'true', // data?.isCourseCatalog, ahora viene de flash.config
    isProgressiveCertification,
    isIntentionEnrollment: data.enable_intension_matricula === 'true', // data?.isIntentionEnrollment, ahora viene de flash.config
    isEnrollmentButtonEnabled: data.enrollment_button_portal === 'true',
    enrollmentPeriodName: data.enrollment_period_name,
    enabledExams: data.portal_enable_exams === 'true',
    currentPeriod: currentPeriod?.period, // data.current_utp_period,
    enablePendDocs: data.enable_popup_documents === 'true',
    enrolmentPeriod: data.enrollment_period_code,
    enrollmentStartClasses: dateNumberToString(
      new Date(data.enrollment_start_classes).getTime(),
      'small'
    ),
    enrollmentEndEnrollment: dateNumberToString(
      new Date(data.enrollment_end_enrollment).getTime(),
      'small'
    ),
    enroledInCurrent:
      Number.parseInt(data.enrollment_period_code, 10) ===
      Number.parseInt(dataProfile.academic.period.id, 10),
    procedureWhiteList: data.procedure_white_list?.split(','),
    eventPenalties: JSON.parse(data.event_penalties),
    procedureInHome: parseInt(data.portal_procedure_in_home, 10),
    restrictStudentPhoto: data.restrict_student_photo === 'true'
  };
};

export default useExternalSettings;
